<template>
  <form @submit.prevent="save">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Withdraw Timesheet?</p>
      </header>
      <section class="modal-card-body">
        <div class="mb-md">
          <div class="has-text-centered py-xl">
            <p class="mb-lg">
              By withdrawing your timesheet, you will be able to make changes,
              but you must resubmit your hours once complete!
            </p>
            <p>Are you sure you want to continue?</p>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot space-between">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <b-button
          type="is-primary"
          native-type="submit"
          :loading="saving"
          :disabled="saving"
        >Withdraw for Changes</b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['api', 'context'])
  },
  methods: {
    save () {
      this.saving = true
      const endpoint = this.api.route + '/timesheets/' + this.timesheet.id
      this.$http.patch(endpoint, { withdraw: 1 }).then(response => {
        this.$parent.close()
        this.$buefy.toast.open({ type: 'is-success', message: 'Timesheet withdrawn!' })
        this.$emit('timesheet:saved')
      }).catch(error => {
        this.errors = error.response.data.errors
        this.$buefy.toast.open({ type: 'is-danger', message: 'Please review your input and try again.' })
      }).finally(() => {
        this.saving = false
      })
    }
  },
  data () {
    return {
      saving: false,
      errors: {}
    }
  },
  props: {
    seat: {
      type: Object,
      required: true
    },
    period: {
      type: Object,
      required: true
    },
    timesheet: {
      type: Object,
      required: true
    }
  }
}
</script>
